import React, { useMemo } from 'react';
import { CalendarEventHelper } from './useCalendarEvents';
import { EventType } from './types';
import { MonthYear } from '../Calendar';
import { View } from 'react-native';
import { DateTime } from 'luxon';
import { getColorForEventTypes } from './utils';
import Text from '../Text';

export type YearScanMonthDisplayOwnProps = {
    monthYear: MonthYear;
    calendarEventHelper: CalendarEventHelper;
    eventTypeFilter: EventType;
};

export type YearScanMonthDisplayProps = YearScanMonthDisplayOwnProps;

const YearScanMonthDisplay: React.FC<YearScanMonthDisplayProps> = (props) => {
    const eventTypes = useMemo(
        () => props.calendarEventHelper.getMonthYearEventTypes(props.monthYear, props.eventTypeFilter),
        [props.calendarEventHelper, props.eventTypeFilter, props.monthYear],
    );

    return (
        <View
            style={{
                alignSelf: 'stretch',
                height: '100%',
                padding: 2,
            }}
        >
            <View
                style={{
                    backgroundColor: getColorForEventTypes(eventTypes),
                    borderRadius: 4,
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '100%',
                }}
            >
                <Text variant="body-1">
                    {DateTime.fromObject({
                        month: props.monthYear.month,
                        year: props.monthYear.year,
                        day: 1,
                    }).toFormat('LLLL')}
                </Text>
            </View>
        </View>
    );
};

export default React.memo(YearScanMonthDisplay);
